<template>
  <div class="base">
    <inside-header />
    <div class="main">
      <div class="title">
        <!-- 我从不轻易认输，直到陪孩子读书我从不轻易认输，直到陪孩子读书 -->
        {{ info.title }}
      </div>
      <a-divider />
      <div class="author-info">
        <img class="header-img" src="@/assets/test-header.png">
        <span class="name">{{ info.nick_name }}</span>
        <div class="fulltime-icon" />
        <span class="time">{{ info.create_time | dayFormat }}</span>
      </div>
      <div style="margin-top:28px;">
        <p v-html="info.content">
          <!-- 明代郎瑛从夏禹时仪狄造酒的传说和“罗”出现于汉代等证据推断《素问》产生于西汉时期。 [22]<br>
          &nbsp;&nbsp;现代中医学专家刘长林 [23]  、吴文鼎 [24]  等人也持这种意见。其主要理由是：其一，《黄帝内经》全书约计20万字，这在2000多年前可以说是一部巨著。编著这样的医籍需要有一个安定的社会环境，需要花费巨大的人力、物力，这在战事连年、七雄割据的战国时代是不可能办到的。只有在西汉时期，随着政治的稳定，经济的发展，才为医学家编著医籍提供了现实的条件；其二，西汉初淮南王刘安的《淮南子·修务训》曰：“世俗人多尊古而贱今，故为道者必记之神农、黄帝而后能入说。”《黄帝内经》在书名和思想内容上与“黄老学派”的密切联系，也、纠略序》、程敏政《新安文献集·运气说》、黄省曾《五岳山人集·内经注辨序》等人也赞同吕复。 [25]<br>
          &nbsp;&nbsp;比较科学的观点是，《黄帝内经》并不是由一个作者完成于一个短时间内，是多个作者跨越了一个较长的时间段集结而成：<br>
          &nbsp;&nbsp;一、先秦文体多韵语，而《黄帝内经》中一些篇章亦有不少韵语，这些章节可能是先秦时期的作品。<br>
          &nbsp;&nbsp;二、与1973年长沙马王堆的帛书《足臂十一脉的“六王斌盘”和“太乙九宫占盘”相比较，可知《灵柩》中有些篇章成书于春秋战国时，有些成书于西汉更早。 [6]<br>
          &nbsp;&nbsp;三、《黄帝内经》中引用的一些文献，如《上下经》、《睽度》等是战国甚至更早的著作。<br> -->
        </p>
      </div>
      <div class="reply-area">
        <div class="title">
          <span>评价</span>
          <span>({{ info.reply_count }})</span>
        </div>
        <div class="reply-list">
          <div v-for="(reply, index) in reply_data" v-show="index < 4 || showPicker" :key="index" class="item"
            style="margin-top:18px;">
            <a-row>
              <a-col :span="5" class="head-img">
                <img src="@/assets/test-header.png" alt="" style="width:60px;">
              </a-col>
              <a-col :span="19" class="reply-message-area">
                <div class="name">
                  {{ reply.reply_nick_name }}
                </div>
                <div class="message">
                  {{ reply.content }}
                </div>
                <div v-show="!commit_switch_status[reply.id]" class="reply-label" @click="switchCommitOpen(reply.id)">
                  评论({{ reply.reply_count }})
                </div>
                <div v-show="commit_switch_status[reply.id]" class="pack-up" @click="switchCommitShrink(reply.id)">
                  <span>收起</span>
                  <span>
                    <a-icon style="color: #999" type="down" />
                  </span>
                </div>
                <!-- 回复评论的，给一个状态，显示还是不显示 -->
                <div v-show="commit_switch_status[reply.id]" class="reply-order">
                  <div class="reply-write">
                    <a-input style="width:70%;" placeholder="写下你的回复" />
                    <a-button style="margin-left:10px;width:60px;" type="primary"
                      @click="replyChildren($event, reply.id)">
                      回复
                    </a-button>
                  </div>
                  <!-- 子回复 -->
                  <a-row v-for="(childItem, i) in reply.child" :key="i" class="child-reply-item">
                    <a-col :span="3" class="head-img">
                      <img src="@/assets/test-header.png" alt="" style="width:30px;">
                    </a-col>
                    <a-col :span="21" class="reply-message-area">
                      <span class="name">{{ childItem.reply_nick_name }}</span>
                      <span>回复</span>
                      <span>{{ childItem.nick_name }}</span>
                      <div class="message">
                        {{ childItem.content }}
                      </div>
                      <!-- <div>
                          <a-button>收起</a-button>
                          <a-button>回复</a-button>
                        </div>
                        <div class="reply-child-area">
                          <a-input></a-input>
                          <a-button>回复</a-button>
                        </div> -->
                      <div class="reply-count">
                        <a-button v-show="!child_commit_switch_status[childItem.id]" type="link"
                          @click="switchChildCommitOpen(childItem.id)">
                          回复
                        </a-button>
                        <!-- 回复（{{ reply.child.length }}） -->
                        <a-button v-show="child_commit_switch_status[childItem.id]" type="link"
                          @click="switchChildCommitShrink(childItem.id)">
                          收起回复
                        </a-button>
                      </div>
                      <div v-show="child_commit_switch_status[childItem.id]" class="child-reply-input">
                        <a-input style="width: 60%;" placeholder="写下你的回复" />
                        <a-button style="margin-left: 20px;width: 60px;" type="primary"
                          @click="replyChildren($event, reply.id)">
                          回复
                        </a-button>
                      </div>
                    </a-col>
                  </a-row>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
      <div class="show-all">
        <a-button type="link" color="fa750d" @click="showPicker = !showPicker">
          {{ showPicker ? '折叠' : '查看全部' }}
          <a-icon type="double-right" :rotate="showPicker ? 270 : 90" />
        </a-button>
      </div>
    </div>
    <!-- 评论区 -->
    <div v-show="showComit" style="margin-top:20px;padding:0 15px;">
      <a-textarea v-model="commit" placeholder="输入你的评论" style="width:70%" :rows="3" />
      <a-button style="margin-left: 20px;width: 65px;" :loading="state.commitBtnLoading" type="primary"
        @click="onCommit">
        评论
      </a-button>
    </div>
    <div class="thumbs-comment">
      <a-row>
        <a-col :span="12" class="thumbs">
          <div v-if="!account_is_like" :loading="state.likeBtnLoading" @click="onLike">
            <span>
              <a-icon type="like" />
            </span>
            <span>点赞</span>
          </div>
          <div v-else :loading="state.cancelLikeBtnLoading" @click="onCancelLike">
            <span>
              <a-icon type="dislike" />
            </span>
            <span>已点赞</span>
          </div>
        </a-col>
        <a-col :span="12" class="comment">
          <span>
            <a-icon type="message" />
          </span>
          <span @click="showComitMethod">评论</span>
        </a-col>
      </a-row>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'

export default {
  name: 'ForumInfo',
  components: {
    MainFooter,
    InsideHeader
  },
  props: {
    id: {}
  },
  data() {
    return {
      loading: true,
      state: {
        likeBtnLoading: false,
        cancelLikeBtnLoading: false,
        commitBtnLoading: false
      },
      info: '',
      list: [],
      replyData: [],
      hotTopic: [],
      account_is_like: false,
      account_is_login: false,
      like_count: 0,
      showComit: false,
      reply_data: [],
      commit_switch_status: {},
      child_commit_switch_status: {},
      commit: '',
      showPicker: false
    }
  },
  created() {
    this.loadData(this.id)
  },
  methods: {
    showComitMethod() {
      this.showComit = !this.showComit
    },
    loadData(id) {
      this.$http({
        url: 'index/forum/info',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        if (res.status === 'success') {
          console.log(1, res)
          var data = res.data
          this.hotTopic = data.hot_topic
          this.info = data.info
          this.list = data.personal_list.list
          this.replyData = data.reply_data
          this.account_is_like = data.account_is_like
          this.account_is_login = data.account_is_login
          this.like_count = data.info.like_count
          this.reply_data = data.reply_data
        }
      })
    },
    onLike() {
      // 点赞
      this.state.likeBtnLoading = true
      this.$http({
        url: 'index/forum/like',
        method: 'post',
        data: {
          forum_id: this.id
        }
      }).then(res => {
        if (res.status === 'success') {
          this.account_is_like = true
          // 点赞数+1
          this.like_count = this.like_count + 1
        } else {
          this.$toast.fail(res.message)
        }
      }).finally(() => {
        this.state.likeBtnLoading = false
      })
    },
    onCancelLike() {
      // 已点赞（取消点赞）
      this.state.cancelLikeBtnLoading = true
      this.$http({
        url: 'index/forum/cancelLike',
        method: 'post',
        data: {
          forum_id: this.id
        }
      }).then(res => {
        if (res.status === 'success') {
          this.account_is_like = false
          // 点赞数-1
          this.like_count = this.like_count - 1
        } else {
          this.$notification.error({
            message: res.status,
            description: res.message
          })
        }
      }).finally(() => {
        this.state.cancelLikeBtnLoading = false
      })
    },
    switchCommitOpen(commitId) {
      this.$set(this.commit_switch_status, commitId, true)
    },
    switchCommitShrink(commitId) {
      this.$set(this.commit_switch_status, commitId, false)
    },
    switchChildCommitOpen(commitId) {
      this.$set(this.child_commit_switch_status, commitId, true)
    },
    switchChildCommitShrink(commitId) {
      this.$set(this.child_commit_switch_status, commitId, false)
    },
    replyChildren(e, pid) {
      var selectedBedDom = e.currentTarget // dom元素
      var parentNode = selectedBedDom.parentNode
      var inputEle = parentNode.getElementsByTagName('input')[0]
      var commitValue = inputEle.value
      if (commitValue === '') {
        return false
      }
      // commitValue
      selectedBedDom.setAttribute('disabled', true)
      this.$http({
        url: '/index/forum/reply',
        method: 'post',
        data: {
          forum_id: this.id,
          pid: pid,
          content: commitValue
        }
      }).then(res => {
        if (res.status === 'success') {
          // 评论成功，按钮重置
          selectedBedDom.setAttribute('disabled', false)
          // 清空评论框
          inputEle.value = ''
          // 重新加载数据
          this.loadData(this.id)
        } else {
          this.$toast.fail(res.message)
        }
      }).finally(() => {
        selectedBedDom.setAttribute('disabled', false)
      })
    },
    onCommit() {
      if (this.commit !== '') {
        this.state.commitBtnLoading = true
        this.$http({
          url: '/index/forum/reply',
          method: 'post',
          data: {
            forum_id: this.id,
            pid: 0,
            content: this.commit
          }
        }).then(res => {
          if (res.status === 'success') {
            // 评论成功，按钮重置
            this.state.commitBtnLoading = false
            // 清空评论框
            this.commit = ''
            // 重新加载数据
            this.loadData(this.id)
          } else {
            this.$toast.fail(res.message)
          }
        }).finally(() => {
          this.state.commitBtnLoading = false
        })
      }
    }
  }
}
</script>
<style lang="stylus">

  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
}

.main {
  padding: 0 15px;
  .title {
    font-family: PingFang-SC-Bold;
    font-size: 21px;
    line-height: 30px;
    color: #333333;
    font-weight: bold;
  }

  .author-info {
    width: 100%;
    line-height: 18px;
    margin-top: 15px;
    overflow: hidden;

    img {
      float: left;
      width: 17px;
      height: 17px;
      border-radius: 50%;
    }

    .name {
      font-family: PingFang-SC-Bold;
      font-size: 12px;
      line-height: 16px;
      color: #333333;
      float: left;

      margin-left: 10px;
      margin-right: 10px;
    }

    .time {
      font-family: PingFang-SC-Bold;
      font-size: 12px;
      line-height: 16px;
      color: #999999;

      float: right;
    }
  }

  .reply-list {

    .item {
      .head-img {
        weight: 60px;
        height: 60px;
        border-radius: 50%;
      }

      .reply-message-area {
        padding: 5px 0px;
        .name {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 22px;
          color: #666666;
        }
        .reply-order {
          .reply-write {
            margin-top: 14px;
          }
        }

        .message {
          font-family: PingFang-SC-Regular;
          font-size: 14px;
          line-height: 20px;
          color: #333333;

          margin-top: 10px;
        }

        .reply-label {
          font-family: PingFang-SC-Bold;
          font-size: 14px;
          line-height: 24px;
          color: #fa750d;
          font-weight: bold;
          margin-top: 10px;
        }

        .child-reply-item {
          margin-top: 10px;

          .head-img {
            img {
              width: 30px;
              height: 30px;
            }
          }
        }

        .pack-up {
          margin-top: 10px;

          span:first-child {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            line-height: 16px;
            color: #d2d2d2;
          }

          span:nth-child(2) {
            margin-left: 5px;
          }
        }
      }
    }
  }

  .show-all {
    margin-top: 40px;

    button {
      width:100%;
      height:40px;
      background-color:#f6f6f6;
      border-radius:10px;
      border:none;
      color:#333333;
    }
  }
}

  .thumbs-comment {
    height: 40px;
    background-color: #fff;
    line-height: 40px;
    text-align: center;
    margin-top: 40px;

    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;

    .thumbs {
      span:first-child {
        color: #fa750d;
      }

      span:nth-child(2) {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 18px;
        color: #fcab6a;

        margin-left: 5px;
      }
    }

    .comment {
      span:nth-child(2) {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 18px;
        color: #333333;
        margin-left: 5px;
      }
    }
  }

</style>
